<template>
	<router-view v-if="isUse" />
	<div v-else class="notice_pop flex_center">
		<div>
			<div class="flex_center">
				<img style="width: 210px; height: 140px" src="./assets/chrome_web_image.png" />
			</div>
			<p class="notice_text" style="margin-top: 20px">为保障页面功能正常运行并获得最佳浏览体验</p>
			<p class="notice_text">建议您使用最新版 Google Chrome 浏览器访问本网站。</p>
		</div>
	</div>
</template>
<script setup>
import { ref, onMounted, watch } from "vue";
import Notify from "@wcjiang/notify";
import { useRoute, useRouter } from "vue-router";
import mitter from "@/utils/mitt";
const isUse = ref(true);
const route = useRoute();
const router = useRouter();
onMounted(() => {
	// notify.setInterval(200);
	// mitter.on("message", (e) => notify.setTitle(e));
	// notify.setTitle(true);
	const bowser = require("bowser");
	const browser = bowser.getParser(window.navigator.userAgent);
	if (browser.getBrowserName() === "Chrome" && window.navigator.userAgent.includes("MetaSr")) {
		isUse.value = false;
		return;
	}
	if (window.navigator.userAgent.includes("SamanthaDoubao")) {
		isUse.value = false;
		return;
	}
	if (isNumberBrowser()) {
		isUse.value = false;
		return;
	}
	if (browser.getBrowserName() === "Chrome") {
		isUse.value = true;
	} else {
		isUse.value = false;
	}
});
// watch(
// 	() => router.currentRoute.value.path,
// 	(val, old) => {
// 		if (val == "/Chart") {
// 			notify.setTitle();
// 		} else if (val == "/login") {
// 			notify.setTitle("JJ Federation CS Platform");
// 		}
// 	}
// );
const checkIeForNum = () => {
	return (
		(navigator.msPointerEnabled == undefined ? true : navigator.msPointerEnabled) &&
		(navigator.msDoNotTrack == 1 || window.doNotTrack == 1) &&
		((Number(window.screenX) ? window.screenLeft - window.screenX != 8 : false) ||
			((navigator.userAgent.indexOf("MSIE 7.0") != -1 ||
				navigator.userAgent.indexOf("MSIE 8.0") != -1) &&
				console.count == undefined))
	);
};
const checkChromeForNum = () => {
	var uas = navigator.userAgent.split(" "),
		result = false;
	if (uas[uas.length - 1].indexOf("Safari") == -1) {
		return result;
	}
	for (var key in navigator.plugins) {
		if (navigator.plugins[key].filename == "np-mswmp.dll") {
			return !result;
		}
	}
	return result;
};
const isNumberBrowser = () => {
	if (navigator.userAgent.indexOf("Safari") != -1) {
		return checkChromeForNum();
	} else {
		return checkIeForNum();
	}
};
</script>

<style lang="less">
html,
body {
	/*color: #606266;*/
	height: 100vh;
	width: 100vw;
	margin: 0;
	*::-webkit-scrollbar {
		display: none;
	}
}

.notice_pop {
	width: 100vw;
	height: 100%;
	background: #f7f7f7;
	position: fixed;

	.notice_text {
		font-size: 14px;
		color: #000000;
		text-align: center;
	}
}

p {
	margin: 0;
	word-wrap: break-word;
	word-break: break-all;
}
div {
	word-wrap: break-word;
	word-break: break-all;
}
.flex_center {
	display: flex;
	justify-content: center;
	align-items: center;
}
.flex_between {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.flex_common {
	display: flex;
	align-items: center;
}
.flex_row {
	display: flex;
	justify-content: space-between;
}
.flex_box {
	display: flex;
	justify-content: center;
}
.global_none_data {
	margin-top: 25%;
	img {
		width: 48px;
		height: 48px;
	}
	p {
		font-size: 14px;
		color: #999999;
		margin-top: 20px;
		text-align: center;
	}
}
.right_content_container {
	height: calc(100% - 50px);
	padding: 25px 20px;
	position: relative;
	.left_title {
		font-size: 14px;
		color: #999999;
	}
	.add_btn {
		padding: 5px 16px;
		border-radius: 4px;
		background: #a15bff;
		cursor: pointer;
		p {
			font-size: 14px;
			color: #ffffff;
		}
		&:hover {
			background: rgba(161, 91, 255, 0.2);
			p {
				color: #a15bff;
			}
		}
	}
	.table_plate {
		border-radius: 4px;
		background: #ffffff;
		padding: 20px;
		margin-top: 19px;
		height: calc(100% - 92px);
		overflow: auto;
	}
}

.dialog_title {
	font-size: 14px;
	color: #333333;
	margin-bottom: 24px;
}

// element ui修改样式
.el-button--primary {
	--el-button-bg-color: #a15bff !important;
	--el-button-border-color: #a15bff !important;
	--el-button-outline-color: #a15bff !important;
	--el-button-disabled-bg-color: rgba(161, 91, 255, 0.4) !important;
	--el-button-disabled-border-color: rgba(161, 91, 255, 0.4) !important;
}

.el-button {
	--el-button-hover-text-color: #a15bff !important;
	--el-button-hover-bg-color: rgba(161, 91, 255, 0.2) !important;
	--el-button-hover-border-color: rgba(161, 91, 255, 0.2) !important;
	--el-button-active-text-color: #a15bff !important;
	--el-button-active-border-color: rgba(161, 91, 255, 0.2) !important;
	--el-button-active-bg-color: rgba(161, 91, 255, 0.2) !important;
	font-weight: normal !important;
}

.el-input {
	--el-input-focus-border: rgba(161, 91, 255, 0.8) !important;
	--el-input-focus-border-color: rgba(161, 91, 255, 0.8) !important;
}

.el-radio {
	--el-radio-input-border-color-hover: rgba(161, 91, 255, 0.8) !important;
}

.el-radio__input.is-checked .el-radio__inner {
	background: #a15bff !important;
	border-color: #a15bff !important;
}

.el-radio__input.is-checked + .el-radio__label {
	color: #a15bff !important;
}

.el-table__inner-wrapper:before {
	display: none !important;
}
</style>
